module.exports = {
  all: ['code', 'start', 'class.name', 'class.owner', 'classCapacity', 'paid', 'status', 'class.price', 'price', 'discount', 'multipleStudentPrices', 'serviceFeePercentage', 'feeDiscount', 'command'],
  upcoming: [
    'code',
    'start',
    'class.name',
    'createdAt',
    'class.owner',
    'classCapacity',
    'paid',
    'class.price',
    'price',
    'discount',
    'multipleStudentPrices',
    'serviceFeePercentage',
    'feeDiscount',
    'command',
  ],
  approved: ['code', 'start', 'class.name', 'class.owner', 'classCapacity', 'price', 'discount', 'multipleStudentPrices', 'serviceFeePercentage', 'feeDiscount', 'command'],
  pending: ['code', 'start', 'class.name', 'class.owner', 'classCapacity', 'price', 'discount', 'multipleStudentPrices', 'serviceFeePercentage', 'feeDiscount', 'command'],
  cancelled: ['code', 'start', 'class.name', 'class.owner', 'classCapacity', 'paid', 'price', 'discount', 'multipleStudentPrices', 'serviceFeePercentage', 'feeDiscount', 'command'],
  closed: ['code', 'start', 'class.name', 'class.owner', 'classCapacity', 'price', 'discount', 'multipleStudentPrices', 'serviceFeePercentage', 'feeDiscount', 'command'],
};
